var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":10}},[_c('a-col',{attrs:{"span":6}},[_c('inspect',{attrs:{"inspect_type":_vm.inspect_type},on:{"check":_vm.inspectChange}})],1),_c('a-col',{attrs:{"span":14}},[_c('vehicle',{ref:"inspectVehicle",attrs:{"inspect_type":_vm.inspect_type}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }